module.exports = __webpack_public_path__ + "static/media/providerSilverTop3D.8d95f9ac.webp";